import { environment } from "../environment";
import { AsyncResult } from "../models/common/async-result";
import { ClubBookReview, ClubBookReviewSummary } from "../models/clubBookReview";
import api from "./api";

export async function registerClubBookReview(clubId: number, meetId: number, userId: number, starsRating: number, wasRead: number): Promise<ClubBookReview> {
  const url = environment.api.clubBookReview.registerClubBookReview
    .replace('{clubId}', String(clubId))
    .replace('{meetId}', String(meetId))
    .replace('{userId}', String(userId));

  return await api.post(url, {
    wasRead: wasRead,
    starsRating: starsRating
  });
}

export async function getClubBookReview(clubId: number, meetId: number, userId: number): Promise<ClubBookReview> {
  const baseUrl = environment.api.clubBookReview.getByMeetAndUser
    .replace('{clubId}', String(clubId))
    .replace('{meetId}', String(meetId))
    .replace('{userId}', String(userId));
  
  return await api.get(baseUrl).then(res => res.data.success);
}

export async function getClubBookReviewByMeet(clubId: number, meetId: number): Promise<ClubBookReviewSummary> {
  const baseUrl = environment.api.clubBookReview.getSummaryByMeet
    .replace('{clubId}', String(clubId))
    .replace('{meetId}', String(meetId));
  
  return await api.get(baseUrl).then(res => res.data.success);
}
